import InstantRegistrationFormState from "@iewcasia/Store/State/InstantRegistration/InstantRegistrationFormState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: InstantRegistrationFormState = {
    fieldValues: {},
};

const reducer = {
    "Components/InstantRegistrationForm/ClearForm": (draft: Draft<InstantRegistrationFormState>) => {
        draft.fieldValues = {};
    },
    "Components/InstantRegistrationForm/SetFieldValue": (
        draft: Draft<InstantRegistrationFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
